import { render, staticRenderFns } from "./ReportShipmentsByStatus.vue?vue&type=template&id=be84303e&"
import script from "./ReportShipmentsByStatus.vue?vue&type=script&lang=js&"
export * from "./ReportShipmentsByStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports